<div class="invoice-preview" [class.dialog-mode]="isDialogMode">
  <div class="preview-shell">
    <div class="preview-header">
      <div class="header-copy">
        <p class="eyebrow">Receipt Advice</p>
        <div class="header-title-row">
          <h2>Finance Receipt Advice Preview</h2>
          <div class="toolbar" aria-label="Receipt advice actions">
            <mat-slide-toggle
              class="sign-toggle"
              color="primary"
              [checked]="includeSignature"
              (change)="onSignatureToggle($event.checked)">
              Sign + Stamp
            </mat-slide-toggle>
            <mat-slide-toggle
              class="sign-toggle"
              color="primary"
              [checked]="showVoucherSection"
              (change)="onVoucherSectionToggle($event.checked)">
              Show JV
            </mat-slide-toggle>
            <button mat-raised-button color="primary" (click)="printPdf()">
              Print
            </button>
            <button mat-stroked-button color="primary" (click)="downloadPdf()">
              Download PDF
            </button>
            <button mat-flat-button color="accent" (click)="sendMail()">
              Mail Receipt
            </button>

            <button
              *ngIf="isDialogMode"
              mat-icon-button
              type="button"
              class="close-preview-button"
              aria-label="Close preview"
              (click)="closePreview()">
              <mat-icon svgIcon="mat:close"></mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="preview-frame" *ngIf="previewData; else loading">
      <div class="invoice-page">
        <div class="invoice-top-strip">
          <span></span>
          <span></span>
        </div>

        <div class="invoice-head">
          <div class="logo-cell">
            <img
              *ngIf="previewData.logo; else logoFallback"
              [src]="previewData.logo"
              alt="Company Logo" />
            <ng-template #logoFallback>
              <div class="logo-fallback">{{ previewData.companyInitials }}</div>
            </ng-template>
          </div>

          <div class="company-cell">
            <div class="document-kicker">Finance Department</div>
            <h1>{{ previewData.companyName | uppercase }}</h1>
            <p *ngIf="previewData.companyAddress">{{ previewData.companyAddress }}</p>
            <p *ngFor="let meta of previewData.companyMeta">{{ meta }}</p>
          </div>

          <div class="invoice-meta-box">
            <div class="meta-badge">RECEIPT ADVICE</div>
            <p><strong>Receipt No:</strong> {{ previewData.voucherNo }}</p>
            <p><strong>Receipt Date:</strong> {{ previewData.voucherDate }}</p>
            <p><strong>Receipt Type:</strong> {{ previewData.receiptType }}</p>
            <p><strong>Mode:</strong> {{ previewData.paymentMode }}</p>
          </div>
        </div>

        <div class="po-overview">
          <div class="overview-card" *ngFor="let card of previewData.overview">
            <span class="overview-label">{{ card.label }}</span>
            <strong>{{ card.value }}</strong>
          </div>
        </div>

        <div class="two-col-info">
          <section class="section-block">
            <h3>Client Details</h3>
            <p class="info-primary">{{ previewData.clientName }}</p>
            <p *ngIf="previewData.clientAddress">{{ previewData.clientAddress }}</p>
            <p *ngFor="let meta of previewData.clientMeta">{{ meta }}</p>
          </section>

          <section class="section-block">
            <h3>Receipt Instructions</h3>
            <p><strong>Branch:</strong> {{ previewData.branchName }}</p>
            <p><strong>Bank:</strong> {{ previewData.bankName }}</p>
            <p><strong>A/C No:</strong> {{ previewData.bankAccountNo }}</p>
            <p><strong>IFSC:</strong> {{ previewData.bankIfsc }}</p>
            <p><strong>Bank Branch:</strong> {{ previewData.bankBranch }}</p>
            <p><strong>Cheque No:</strong> {{ previewData.chequeNo }}</p>
            <p><strong>Cheque Date:</strong> {{ previewData.chequeDate }}</p>
          </section>
        </div>

        <div class="section-block" *ngIf="previewData.hasBillRows">
          <h3>Bill-wise Receipt Advice</h3>
          <table class="items-table compact-table">
            <thead>
              <tr>
                <th>SR</th>
                <th>BRANCH</th>
                <th>BILL NO</th>
                <th>BILL DATE</th>
                <th>GROSS</th>
                <th>RECEIPT AMOUNT</th>
                <th>TDS</th>
                <th>OTHER DED.</th>
                <th>NET RECEIVED</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of previewData.billRows">
                <td class="center">{{ row.sr }}</td>
                <td>{{ row.branchName }}</td>
                <td>{{ row.billNo }}</td>
                <td class="center">{{ row.billDate }}</td>
                <td class="right">{{ row.grossAmount }}</td>
                <td class="right">{{ row.receiptSettlementAmount }}</td>
                <td class="right">{{ row.tdsAmount }}</td>
                <td class="right">{{ row.otherDeductionAmount }}</td>
                <td class="right strong">{{ row.netReceivedAmount }}</td>
              </tr>
              <tr class="grand-row">
                <td colspan="4" class="right">BILL SUMMARY</td>
                <td class="right">{{ previewData.billGrossTotal }}</td>
                <td class="right">{{ previewData.billReceiptSettlementTotal }}</td>
                <td class="right">{{ previewData.billTdsTotal }}</td>
                <td class="right">{{ previewData.billOtherDeductionTotal }}</td>
                <td class="right">{{ previewData.billNetReceivedTotal }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="section-block" *ngIf="previewData.hasAdvanceSection">
          <h3>Advance Summary</h3>
          <table class="items-table compact-table">
            <thead>
              <tr>
                <th>SR</th>
                <th>DESCRIPTION</th>
                <th>ADVANCE AMOUNT</th>
                <th>ADVANCE TDS</th>
                <th>ADVANCE RECEIPT</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of previewData.advanceSectionRows">
                <td class="center">{{ row.sr }}</td>
                <td>{{ row.description }}</td>
                <td class="right">{{ row.advanceAmount }}</td>
                <td class="right">{{ row.advanceTds }}</td>
                <td class="right strong">{{ row.advanceReceipt }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="section-block" *ngIf="previewData.hasDeductionRows">
          <h3>Other Deductions / Settlement Adjustments</h3>
          <table class="items-table compact-table">
            <thead>
              <tr>
                <th>SR</th>
                <th>BILL NO</th>
                <th>BRANCH</th>
                <th>LEDGER</th>
                <th>AMOUNT</th>
                <th>REMARKS</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of previewData.deductionRows">
                <td class="center">{{ row.sr }}</td>
                <td>{{ row.billNo }}</td>
                <td>{{ row.branchName }}</td>
                <td>{{ row.ledgerName }}</td>
                <td class="right strong">{{ row.amount }}</td>
                <td>{{ row.remarks }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="section-block" *ngIf="showVoucherSection && previewData.hasVoucherRows">
          <h3>Voucher Ledger Summary</h3>
          <table class="items-table compact-table">
            <thead>
              <tr>
                <th>SR</th>
                <th>LEDGER</th>
                <th>DEBIT</th>
                <th>CREDIT</th>
                <th>REMARKS</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of previewData.voucherRows">
                <td class="center">{{ row.sr }}</td>
                <td>{{ row.ledgerName }}</td>
                <td class="right">{{ row.debitAmount }}</td>
                <td class="right">{{ row.creditAmount }}</td>
                <td>{{ row.remarks }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="bottom-grid">
          <div class="details-block">
            <section class="words-block">
              <h3>Amount In Words</h3>
              <p>{{ previewData.amountInWords }}</p>
            </section>
            <section *ngIf="previewData.remarks !== '-'">
              <h3>Remarks</h3>
              <p>{{ previewData.remarks }}</p>
            </section>
          </div>

          <div class="summary-sign-block">
            <div class="html-sign-area">
              <div class="sign-company">
                For {{ previewData.companyNameTitle }}
              </div>
              <div class="sign-assets" *ngIf="includeSignature">
                <img
                  *ngIf="previewData.stampImage"
                  class="stamp-img"
                  [src]="previewData.stampImage"
                  alt="Company Stamp" />
                <img
                  *ngIf="previewData.signatureImage"
                  class="signature-img"
                  [src]="previewData.signatureImage"
                  alt="Signature" />
              </div>
              <div class="sign-name" *ngIf="previewData.signatoryName">
                {{ previewData.signatoryName }}
              </div>
              <div class="sign-role">
                {{ previewData.signatoryTitle || "Authorized Signatory" }}
              </div>
            </div>
          </div>
        </div>

        <div class="invoice-footer">
          <div class="footer-line">
            <span></span>
            <span></span>
          </div>
          <div class="footer-text">
            <span>Generated using VCS ERP</span>
            <span>Page 1 of 1</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #loading>
    <div class="loading-state">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <p class="loading-text">
        {{
          includeSignature
            ? "Generating signed receipt preview..."
            : "Generating receipt preview..."
        }}
      </p>
    </div>
  </ng-template>
</div>
